import React, { useEffect } from "react";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { Spinner } from "reactstrap";
import { Button } from "react-bootstrap";
import {
  useUpdateInitialCampaignMutation,
  useGetOneInitialCampaignQuery,
} from "../../../services/campaigns";
import { InitialCampaignForm } from "./InitialCampaignForm";
import { FormActionsFooter } from "@/Component/FormActionsFooter";
import { FormProvider, useForm } from "react-hook-form";
import { useSystem } from "@/utils/hooks/useLocation";

const UpdateInitialCampaign = () => {
  const { currentSystem } = useSystem();
  /**
   * ==================
   * Hooks
   * ==================
   */
  const { t } = useTranslation();
  const { id, mode } = useParams();

  const form = useForm({
    defaultValues: {
      country_id: 98,
      nationality_id: 98,
    },
  });

  /**
   * ==================
   * Queries
   * ==================
   */
  const {
    data: campaignRes,
    isLoading: campaignLoading,
    isFetching: campaignFetching,
  } = useGetOneInitialCampaignQuery({ currentSystem, id });
  const loading = campaignLoading || campaignFetching;

  /**
   * ==================
   * Mutations
   * ==================
   */
  const { mutate: updateInitialCampaign, isPending } =
    useUpdateInitialCampaignMutation(form?.setError, currentSystem);

  /**
   * ==================
   * Constants
   * ==================
   */
  const canAmend = mode === "edit" || mode === "create";
  const campaignData = campaignRes?.data?.data;

  /**
   * ==================
   * Handlers
   * ==================
   */
  const onSubmit = (data) => {
    updateInitialCampaign(data);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (form?.handleSubmit) {
      form.handleSubmit(onSubmit)(e);
    }
  };

  /**
   * ==================
   * Render
   * ==================
   */

  useEffect(() => {
    if (campaignData) {
      form.reset({
        ...campaignData,
        madina_service_center_id: campaignData?.madina_service_center_id ? String(campaignData?.madina_service_center_id) : null,
        service_center_id: campaignData?.service_center_id ? String(campaignData?.service_center_id) : null,
        country_id: campaignData?.country_id ? String(campaignData?.country_id) : null,
        state_id: campaignData?.state_id ? String(campaignData?.state_id) : null,
      });
    }
  }, [campaignData]);

  return (
    <div>
      <PageHeader
        backTo={`/app/${currentSystem}/arrival-campaign`}
        title={
          canAmend
            ? t("UPDATE_INITIAL_CAMPAIGN")
            : t("INITIAL_CAMPAIGN_DETAILS")
        }
      />
      <div className="m-4">
        <form onSubmit={handleFormSubmit} className="d-flex flex-column gap-4">
          <FormProvider {...form}>
            <InitialCampaignForm isLoading={loading} isViewMode={!canAmend} />
          </FormProvider>

          {canAmend && (
            <FormActionsFooter>
              <Button variant="primary" type="submit" disabled={isPending}>
                {isPending && <Spinner size="sm" className="me-2" />}
                {t("UPDATE_INITIAL_CAMPAIGN")}
              </Button>
            </FormActionsFooter>
          )}
        </form>
      </div>
    </div>
  );
};

export default UpdateInitialCampaign;
